"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BoardView_1 = require("../views/BoardView");
var SquareView_1 = require("../views/SquareView");
var PieceView_1 = require("../views/PieceView");
var CoordinateView_1 = require("../views/CoordinateView");
var PreviewPieceView_1 = require("../views/PreviewPieceView");
var DroppableSquare_1 = __importDefault(require("../dnd/DroppableSquare"));
var DraggablePiece_1 = __importDefault(require("../dnd/DraggablePiece"));
exports.defaultRenderBoard = function (_a) {
    var children = _a.children, resizeListener = _a.resizeListener, props = __rest(_a, ["children", "resizeListener"]);
    return (react_1.default.createElement(BoardView_1.BoardView, __assign({}, props),
        resizeListener,
        children));
};
exports.defaultRenderSquare = function (_a) {
    var Coordinate = _a.Coordinate, Piece = _a.Piece, props = __rest(_a, ["Coordinate", "Piece"]);
    return (react_1.default.createElement(SquareView_1.SquareView, __assign({}, props),
        Piece,
        Coordinate));
};
exports.defaultRenderPiece = function (props) { return react_1.default.createElement(PieceView_1.PieceView, __assign({}, props)); };
exports.defaultRenderCoordinate = function (props) { return react_1.default.createElement(CoordinateView_1.CoordinateView, __assign({}, props)); };
exports.defaultRenderPreviewPiece = function (props) { return react_1.default.createElement(PreviewPieceView_1.PreviewPieceView, __assign({}, props)); };
exports.defaultRenderDroppableSquare = function (props) { return react_1.default.createElement(DroppableSquare_1.default, __assign({}, props)); };
exports.defaultRenderDraggablePiece = function (props) { return react_1.default.createElement(DraggablePiece_1.default, __assign({}, props)); };
exports.mergeBoardRenderers = function (_a) {
    var _b = _a.renderBoard, renderBoard = _b === void 0 ? exports.defaultRenderBoard : _b, _c = _a.renderSquare, renderSquare = _c === void 0 ? exports.defaultRenderSquare : _c, _d = _a.renderPiece, renderPiece = _d === void 0 ? exports.defaultRenderPiece : _d, _e = _a.renderCoordinate, renderCoordinate = _e === void 0 ? exports.defaultRenderCoordinate : _e, _f = _a.renderPreviewPiece, renderPreviewPiece = _f === void 0 ? exports.defaultRenderPreviewPiece : _f, _g = _a.renderDroppableSquare, renderDroppableSquare = _g === void 0 ? exports.defaultRenderDroppableSquare : _g, _h = _a.renderDraggablePiece, renderDraggablePiece = _h === void 0 ? exports.defaultRenderDraggablePiece : _h;
    return ({
        renderBoard: renderBoard,
        renderSquare: renderSquare,
        renderPiece: renderPiece,
        renderCoordinate: renderCoordinate,
        renderPreviewPiece: renderPreviewPiece,
        renderDraggablePiece: renderDraggablePiece,
        renderDroppableSquare: renderDroppableSquare
    });
};
